import React from 'react';
import { Link } from 'react-router-dom';

const Terms = () => {
  return (
    <div className="page terms">
      <h1>Terms of Service</h1>
      <p>Last updated: March 24, 2026</p>

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing and using CarEx Marketplace (the &quot;Service&quot;), including
          our mobile application and website operated by <strong>Inspire The Next Inc.</strong>{' '}
          (&quot;Company,&quot; &quot;we,&quot; or &quot;us&quot;), you accept these Terms
          of Service and our{' '}
          <Link to="/privacy-policy">Privacy Policy</Link>.
        </p>
      </section>

      <section>
        <h2>2. Use of Service</h2>
        <p>
          CarEx Marketplace provides a platform for users to buy and sell vehicles and to
          use related tools and optional paid features. You agree to use the Service in
          compliance with all applicable laws and regulations. The Service is offered by
          Inspire The Next Inc. under the CarEx Marketplace brand.
        </p>
      </section>

      <section>
        <h2>3. User Accounts</h2>
        <p>
          To access certain features of the Service, you may be required to create an
          account. You are responsible for maintaining the confidentiality of your account
          credentials and for activity under your account.
        </p>
      </section>

      <section>
        <h2>4. Purchases, fees, refunds, and disputes</h2>
        <p>
          Fees, taxes, and the scope of what you are buying are shown at checkout or in
          the app before you pay. Refunds, returns, cancellations, and dispute resolution
          for marketplace transactions and platform fees are described in our{' '}
          <Link to="/marketplace-policies">Marketplace Policies</Link>. Customer service
          contact information is on our <Link to="/support">Support</Link> page. Nothing in
          these Terms limits any non-waivable rights you may have under applicable law.
        </p>
      </section>

      <section>
        <h2>5. Promotions</h2>
        <p>
          Any promotion, discount code, referral reward, contest, or similar offer is
          subject to these Terms, the specific rules or disclosures shown with that offer,
          and any eligibility or geographic limits we communicate.           Unless we state
          otherwise, promotions cannot be combined, are not transferable, have no cash
          value except as stated, and may be changed or withdrawn where permitted. Abuse
          of promotions (including fraud or circumvention) may result in voiding rewards
          or closing accounts.
        </p>
      </section>
    </div>
  );
};

export default Terms;
